import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { SharedModule } from '../shared/shared.module';
import { HomeComponent } from './home.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessagesModule } from 'primeng/messages';
import { BetaBannerComponent } from './beta-banner/beta-banner.component';
import { AvatarModule } from 'primeng/avatar';
import { AgentBarComponent } from './agent-bar/agent-bar.component';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { MenubarModule } from 'primeng/menubar';
import { UserMenuComponent } from './nav-bar/user-menu/user-menu.component';
import { PanelModule } from 'primeng/panel';
import { DividerModule } from 'primeng/divider';
import { HipaaFormComponent } from '../hipaa-form/hipaa-form.component';

@NgModule({
  declarations: [
    HomeComponent,
    BetaBannerComponent,
    AgentBarComponent,
    NavBarComponent,
    UserMenuComponent,
    HipaaFormComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HomeRoutingModule,
    SharedModule,
    ToastModule,
    MessagesModule,
    AvatarModule,
    ButtonModule,
    SidebarModule,
    MenubarModule,
    PanelModule,
    DividerModule,
  ],
  providers: [MessageService],
})
export class HomeModule {}
